"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToothSurfaceType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ToothSurfaceType_Factory = /** @class */ (function () {
    function ToothSurfaceType_Factory() {
    }
    ToothSurfaceType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    ToothSurfaceType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return ToothSurfaceType_Factory;
}());
exports.ToothSurfaceType_Factory = ToothSurfaceType_Factory;
